export default {"src":"/_next/static/media/delete.b327f121.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};